import { KendoBaseComponent } from '@progress/kendo-base-components-vue-wrapper'
import ColorPaletteProps from './ColorPaletteProps'

import TileSize from '../Common/TileSize'

export default {
    template: '<div></div>',
    props: ColorPaletteProps,
    mixins: [
        KendoBaseComponent,
        TileSize
    ],
    mounted() {
        kendo.jQuery(this.$el).kendoColorPalette(this.widgetOptions)

        this.$emit('kendowidgetready', this.kendoWidget())
    },
    methods: {
        kendoWidget() {
            return kendo.jQuery(this.$el).getKendoColorPalette()
        }
    }
}


// WEBPACK FOOTER //
// ./packages/kendo-inputs-vue-wrapper/src/KendoColorPalette/KendoColorPaletteMixin.js